import React from 'react';

interface ConfirmationDialogProps {
  isOpen: boolean;
  type: 'single' | 'bulk';
  position?: { top: number; left: number };
  dependencyName: string;
  entityLabel?: string; // e.g., 'dependency' | 'milestone'
  isLoading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  isOpen,
  type,
  position,
  dependencyName,
  entityLabel = 'dependency',
  isLoading = false,
  onConfirm,
  onCancel
}) => {
  if (!isOpen || !position) return null;

  return (
    <>
      {/* Backdrop */}
      <button className="delete-backdrop fixed inset-0 z-40" onClick={onCancel} aria-label="Close" />
      
      {/* Dialog */}
      <div 
        className="fixed z-50 bg-light-surfacePrimary dark:bg-secondary-dark rounded-lg shadow-xl p-4 w-64 border border-light-border-default dark:border-gray-700"
        style={{
          top: position.top, // Center vertically relative to cursor
          left: position.left + 215, // Position to the right of cursor
        }}
      >
        <p className="text-sm text-light-text-primary dark:text-gray-300 mb-4 font-medium">
          {type === 'bulk' 
            ? `Delete all ${dependencyName}?`
            : `Remove this ${entityLabel}?`
          }
        </p>
        
        <div className="flex gap-2 justify-end">
          <button
            className="px-3 py-2 text-sm font-medium text-light-text-secondary hover:text-light-text-primary dark:text-gray-400 dark:hover:text-gray-200 hover:bg-light-interactive-hover dark:hover:bg-gray-700 rounded-md transition-colors duration-200 border border-light-border-default dark:border-gray-600"
            onClick={onCancel}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
        className="px-3 py-2 text-sm font-medium text-light-text-inverse bg-light-status-error-text hover:bg-red-700 rounded-md transition-colors duration-200 flex items-center gap-2 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <div className="w-3 h-3 border border-light-text-primary border-t-transparent rounded-full animate-spin" />
                <span className="text-light-text-primary">Deleting...</span>
              </>
            ) : (
              'Delete'
            )}
          </button>
        </div>
      </div>
    </>
  );
};

export default ConfirmationDialog; 